import * as routes from "utils/contants/urls";

import {
  ActionItem,
  Actions,
  Label,
  LabelAction,
  LabelHeader,
  Table,
  TableBody,
  TableColumn,
  TableHead,
  TableRow,
} from "components/shared/CustomComponentsStyle";
import React, { useEffect, useState, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { view } from "assets/icons/icons";
import { Creators as formInputsActions } from "store/ducks/formInputs";
import { Body } from "./ListDoubtsCandidatesStyle";
import BreadCrumb from "components/Layout/breadcrumb";

import { Button, Form, Modal,  Card, ListGroup } from "react-bootstrap";

import {
  MultSelectCreatable,
  MultSelect,
  CheckBox,
  ButtonSecondary,
  DatePicker,
  TextField,
} from "components/shared/CustomInputs";
import { Collapse } from "components/shared/CustomComponents";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import Load from "components/Layout/Load";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Creators as doubtsAction } from "store/ducks/doubts";
import Pagination from "components/Pagination";
import { Creators as candidatesAction } from "store/ducks/candidates";
import { StatusMotivoDoContato, StatusDuvidaContato } from "utils/contants/enums";
import { Creators as messageAction } from "store/ducks/messages";




const RowColorStage = (status) => {
  let color;
  switch (status) {
    case 0:
      color = "	#FFD700";
      break;
    case 1:
      color = "	#F0E68C";
      break;
    case 2:
      color = "	#32CD32";
      break;
    case 3:
      color = "#A020F0";
      break;
    default:
      color = "#FFFFE0";
      break;
  }

  return {
    color,
    height: "18px",
    width: "18px",
    borderRadius: "50%",
    float: "left",
    display: "inline-block",
    backgroundColor: color,
  };
};

const redirect = (url) => {
  window.location.href = url;
};

const ListDoubtsCandidates = ({
  doubtsListRequest,
  ListDoubts,
  duvidas,
  candidates,
  isLoading,
  pagination,
  location,

  messagePublication,
  hasMore,
  doubtsAnswersRequest
}) => {

  const [clearFilter, setClearFilter] = useState(false);

  
  const [formValues, setFormValues] = useState({
    cpfs: [],
    idVagas: [],
    idLocations: [],
    dataAdmissao: "",
    nomeFuncionario: "",
    vaga_Id: "",
    motivo: "",
    assunto: "",
    descricao: "",
    statusDuvida: "",
    candidato_Id: "",
    respostaAdm: "",
    idStatus:[],
    idMotivoList: [],
    id: "",
  });
  

  const formValuesRef = useRef([formValues]);


  const [erroMessage, setErroMessage] = useState({ message: "" });
  const [contextDuvidas, setContextDuvidas] = useState([]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = (duvida) =>{ 
      formValuesRef.current = duvida
      setShow(true)
    };


  const AplicaFiltro = (form, firstPage) => {
    localStorage.setItem("filter_ListDoubtsCandidates", JSON.stringify(form));
    doubtsListRequest({
      cpfList: form.cpfs,
      idStatusList: form.idStatus,
      idMotivoList: form.idMotivoList,
      firstPage,
            });
    setFormValues(form);
  };

  const loadMore = () => {
    setClearFilter(false);
    AplicaFiltro(formValues, false);
  };

  useEffect(() => {
    if (candidates.candidatos != undefined && candidates.candidatos.length) {
      const dupContextList = candidates.candidatos.map((candidate) => {
        return { ...candidate, selected: false };
      });

      setContextDuvidas(dupContextList);
      
    }

    let filter_storaged = JSON.parse(
      localStorage.getItem("filter_ListDoubtsCandidates")
    );
    if (filter_storaged != null && !clearFilter) {
      filter_storaged.quantidadeItens = candidates.candidatos
        ? candidates.candidatos.length
        : 20;
      localStorage.setItem(
        "filter_ListDoubtsCandidates",
        JSON.stringify(filter_storaged)
      );
      setFormValues(filter_storaged);
    } else {
      setFormValues({
        cpfs: [],
        idVagasList: [],
        idVagas: [],
        idLocations: [],
        idStatus: [],
        idMotivoList:[],
        dateInitActivity: null,
      });
    }

    if (candidates.candidatos == undefined) {
      AplicaFiltro(formValues, true);
    }
  }, [candidates]);

  const Filtrar = () => {
    setClearFilter(false);
    AplicaFiltro(formValues, true);
  };

  const getMotivoEtapaValues = () => {
    if (formValues.idMotivoList) {
      return StatusMotivoDoContato.filter(function (item) {
        return formValues.idMotivoList.indexOf(item.value) !== -1;
      });
    }

    return [];
  };

  const getStatusEtapaValues = () => {
    if (formValues.idStatus) {
      return StatusDuvidaContato.filter(function (item) {
        return formValues.idStatus.indexOf(item.value) !== -1;
      });
    }

    return [];
  };


  const LimparFiltro = () => {
    setClearFilter(true);
    localStorage.removeItem("filter_ListDoubtsCandidates");
    setFormValues({});
    AplicaFiltro({}, true);
  };

  const sendResposta = (id, candidato_Id, respostaAdm) => {
    doubtsAnswersRequest({ id: id, candidato_Id: candidato_Id, respostaAdm: respostaAdm });
    handleClose()
  }

  const TrataMultiInsert = (Insert) => {
    setErroMessage({ message: "" });
    let messages = [];
    let result = [];
    Insert.map((item) => {
      let conc = item.value.split(/[\s,]+/);
      conc.map((filtItem) => {
        if (filtItem.length == 11) {
          result.push(filtItem);
        } else {
          messages.push({
            message: `motivo ${filtItem} com menos de 11 digitos. Não será considerado no filtro.`,
            type: "warning",
          });
        }
      });
    });
    messagePublication(messages);
    return result;
  };

  const selectCandidate = (id) => {
    const dupContextList = contextDuvidas.map((item) => {
      if (item.idCandidatoNaEtapa === id) {
        item.selected = !item.selected;
      }
      return item;
    });
    setContextDuvidas(dupContextList);
  };

  const requestPage = (filter) => { 

    doubtsListRequest({ NumeroPagina: filter.NumeroPagina});
  };
  const renderTableItems = (duvidasList) =>
    duvidasList.map((duvida) => (
      <TableRow>
        <TableColumn>
          <span class="dot" style={RowColorStage(duvida.statusDuvida)} />
        </TableColumn>
        <TableColumn ta="left">
          <Label>{duvida.candidato}</Label>
        </TableColumn>
        <TableColumn ta="left">
          <Label>{duvida.dataCriacao}</Label>
        </TableColumn>
        <TableColumn ta="left">
          <Label>
            {
              StatusMotivoDoContato.find(
                (motivo) => motivo.value == duvida.motivo
              ).label
            }
          </Label>
        </TableColumn>
        <TableColumn ta="right" action>
          <Link onClick={ () => handleShow(duvida)}>
            <Actions flexPosition="flex-start">
              <ActionItem>
                {view()}
                <LabelAction>
                  <FormattedMessage id="sharedItems.view" />
                </LabelAction>
              </ActionItem>
            </Actions>
          </Link>
        </TableColumn>
      </TableRow>
    ));
     const RenderModalMessageCandidato = ({
       show,
       handleClose,
       formValeusModal,
       sendResposta,
       setFormValuesModal,
       id,
       candidato_id,
     }) => {  
      
      const [respostaAdm, setRespostaAdm] = useState('');
      const MotivoStatus = (tipos) => {
        var tipoMotivo;
    
        switch (tipos){
          case 0 :
            tipoMotivo = "Erro Sistemico";
            break;
          case 1 :
            tipoMotivo = "Duvida Processo Seletivo";
            break;
          case 2 :
            tipoMotivo = "Reclamação Processo seletivo";
            break;
          default :
            tipoMotivo = "Outros";
            break;
          }
          return tipoMotivo;
        }

     return(
       <Modal centered={true} show={show} onHide={handleClose}>
       <Modal.Header closeButton>
         <Modal.Title style={{color:"#005156"}}><FormattedMessage id="duvidasCandidate.detalhes" /></Modal.Title>
       </Modal.Header>
       <Modal.Body>
         <Form>
           <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
             <Form.Label > <FormattedMessage id="duvidasCandidate.nomeCandidato" /></Form.Label>
             <Form.Control
               type="text"
               value={formValeusModal.candidato}
                disabled
             />
           </Form.Group>
           <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
             <Form.Label > <FormattedMessage id="duvidasCandidate.dataDoChamado" /></Form.Label>
             <Form.Control
               type="text"
               value={formValeusModal.dataCriacao}
                disabled
             />
           </Form.Group>
           <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
             <Form.Label > <FormattedMessage id="duvidasCandidate.motivoDoContato" /></Form.Label>
             <Form.Control
               type="text"
               value={MotivoStatus(formValeusModal.motivo)}
                disabled
             />
             
           </Form.Group>
   
           <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
               <Form.Label > 
                 <FormattedMessage id="duvidasCandidate.descricao" />
               </Form.Label>
             <Form.Control
               as="textarea" rows={4} 
               value={formValeusModal.descricao}
               disabled
             />
           </Form.Group>
           
           <Form.Group
             className="mb-3"
             controlId="exampleForm.ControlTextarea1"
           >
             <Form.Label  >
               <FormattedMessage id="duvidasCandidate.responder" />
             </Form.Label>
             <Form.Control 
               as="textarea" 
               rows={4}  
               value={formValeusModal.respostaAdm}
               disabled={formValeusModal.respostaAdm == null ? false : true}
               onChange={(e) => setRespostaAdm(e.target.value)}
             />
           </Form.Group>
         </Form>
       </Modal.Body>
       <Modal.Footer>
         <Button variant="danger" onClick={handleClose}>
           {formValeusModal.respostaAdm == null ? "Cancelar" : "Fechar"}
         </Button>
         <Button variant="success" 
          disabled={formValeusModal.respostaAdm == null ? false : true}
          onClick={() => {
            setFormValuesModal({ ...formValeusModal, respostaAdm });
            sendResposta(id, candidato_id, respostaAdm);
            handleClose();
          }}>
           Responder
         </Button>
         
       </Modal.Footer>
     </Modal>
     ); }

  const renderCandidatesTable = () => {
    return (
      <>
      <Table>
        <TableBody>
          <TableRow noBorder>
            <TableHead>
              <LabelHeader>
                <FormattedMessage id="duvidasCandidateList.status" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="duvidasCandidateList.nomeCandidato" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="duvidasCandidateList.dataDoChamado" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="duvidasCandidateList.motivoDoContato" />
              </LabelHeader>
            </TableHead>
            <TableHead ta="left">
              <LabelHeader>
                <FormattedMessage id="duvidasCandidateList.descricao" />
              </LabelHeader>
            </TableHead>
          </TableRow>
          {renderTableItems(duvidas)}
        </TableBody>
      </Table>
      <Pagination getItemsPage={requestPage} pageSize={50} {...pagination} />
      </>
    );
  };

  const renderCandidatesByGroupTable = (duvidasList) =>
    duvidasList.map((duvidas) => (
      <Collapse
        typeStatus={0}
        position={0}
        title={`Vaga ${duvidas.idVaga} - ${duvidas.nomeVaga}`}
      >
        <Table>
          <TableBody>
            <TableRow noBorder>
              <TableHead>
                <LabelHeader>
                  <FormattedMessage id="documentsduvidasList.motivo" />
                </LabelHeader>
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>
                  <FormattedMessage id="documentsduvidasList.nomeCandidato" />
                </LabelHeader>
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>
                  <FormattedMessage id="documentsduvidasList.documentosEnviados" />
                </LabelHeader>
              </TableHead>
              <TableHead ta="left">
                <LabelHeader>
                  <FormattedMessage id="documentsduvidasList.status" />
                </LabelHeader>
              </TableHead>
              <TableHead ta="left">
                <LabelHeader ta="center">
                  <FormattedMessage id="documentsduvidasList.visualizar" />
                </LabelHeader>
              </TableHead>
            </TableRow>
            {renderTableItems(duvidas)}
          </TableBody>
        </Table>
      </Collapse>
    ));

  if (isLoading) return <Load isLoading={isLoading} />;
  return (
    <React.Fragment>
      <BreadCrumb
        location={location}
        title={<FormattedMessage id="menuTalentBar.selectCandidate" />}
      />
      <Body>
        <Row style={{ marginBottom: "10px"}}>
          <Col style={{display: "flex", justifyContent:"flex-start"}}>
          <Col md={4}>
            <MultSelectCreatable
              key={5}
              name={<FormattedMessage id="documentsCandidateList.filterCpf" />}
              label={<FormattedMessage id="documentsCandidateList.filterCpf" />}
              isMulti
              options={formValues.cpfs}
              value={
                formValues.cpfs
                  ? formValues.cpfs.map((e) => ({
                      label: e,
                      value: e,
                    }))
                  : []
              }
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  cpfs: e ? TrataMultiInsert(e) : [],
                })
              }
            />
          </Col>
          <Col md={4}>
            <MultSelect
              name={<FormattedMessage id="contracts.motivoDoContato" />}
              options={StatusMotivoDoContato}
              label={<FormattedMessage id="contracts.motivoDoContato" />}
              isMulti
              value={getMotivoEtapaValues()}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  idMotivoList: e
                    ? e.map((k) => {
                        return k.value;
                      })
                    : [],
                })
              }
            />
          </Col>
          <Col md={4}>
            <MultSelect
              name={<FormattedMessage id="contracts.status" />}
              options={StatusDuvidaContato}
              label={<FormattedMessage id="contracts.status" />}
              isMulti
              value={getStatusEtapaValues()}
              onChange={(e) =>
                setFormValues({
                  ...formValues,
                  idStatus: e
                    ? e.map((k) => {
                        return k.value;
                      })
                    : [],
                })
              }
            />
          </Col>
          </Col>

          <Col style={{display: "flex", justifyContent:"flex-end"}}>
          <Col md={5} style={{ marginTop: "15px" }}>
            <ButtonSecondary
              onClick={() => Filtrar()}
              name={<FormattedMessage id="sharedItems.filter" />}
            />
          </Col>
          <Col md={5} style={{ marginTop: "15px" }}>
            <ButtonSecondary
              onClick={() => LimparFiltro()}
              name={<FormattedMessage id="sharedItems.clearFilter" />}
            />
          </Col>
          </Col>
        </Row>

        
        {duvidas && renderCandidatesTable(duvidas)}
        {/* <ButtonSecondary
          disabled={!hasMore}
          onClick={loadMore}
          isLoading={isLoading}
          name={<FormattedMessage id="sharedItems.loadMore" />}
        /> */}
       
  </Body>

  
  <RenderModalMessageCandidato
      show={show}
      handleClose={handleClose}
      formValeusModal={formValuesRef.current}
      sendResposta={sendResposta}
      setFormValuesModal={setFormValues}
      id={formValuesRef.current.id}
      candidato_id={formValuesRef.current.candidato_Id}
    />
  
    </React.Fragment>
  );
};

const mapDispatchToProps = (dispatch) => ({
  doubtsListRequest: (filter) =>
    dispatch(doubtsAction.doubtsListRequest(filter)),
    doubtsAnswersRequest: (filter) =>
    dispatch(doubtsAction.doubtsAnswersRequest(filter)),
    messagePublication: messages => dispatch(messageAction.messagePublication(messages)),
});

const mapStateToProps = (state) => ({
  isLoading: state.doubts.isLoading,
  duvidas: state.doubts.duvidas,
  placesOfWork: state.formInputs.placeOfWork,
  pagination: state.doubts.pagination,
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListDoubtsCandidates);

ListDoubtsCandidates.propTypes = {
  candidates: PropTypes.func,
  hasMore: PropTypes.any,
  quantidadeItens: PropTypes.any,
};

ListDoubtsCandidates.defaultProps = {
  candidates: () => {},
};
